import { render, staticRenderFns } from "./SharedItems.vue?vue&type=template&id=55b2c747&scoped=true"
import script from "./SharedItems.vue?vue&type=script&lang=js"
export * from "./SharedItems.vue?vue&type=script&lang=js"
import style0 from "./SharedItems.vue?vue&type=style&index=0&id=55b2c747&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b2c747",
  null
  
)

export default component.exports